import { useAuth0 } from "@auth0/auth0-react"
import { FC, useState } from "react";
import { Dispatches } from "./Dispatches";
import { WebhookConnector } from "../../Components/Webhook";
export const DispatchWrapper: FC = () => {
    const { user } = useAuth0();
    const [webhookConnector, setWebhookConnector] = useState<WebhookConnector>(new WebhookConnector(user?.sub ?? ''));

    return <Dispatches webhookConnector={webhookConnector} setWebhookConnector={setWebhookConnector} />;
}